import { required, email, sameAs, minLength, maxLength, not } from 'vuelidate/lib/validators'
import { hasSpecialCharacter, hasLowercase, hasUppercase, hasNumeric, passesApiValidation } from '@/plugins/vuelidate/validators'

export const validations = {
    email: {
        required,
        maxLength: maxLength(100),
        email,
        passesApiValidation: passesApiValidation('email')
    },
    password: {
        required,
        minLength: minLength(12),
        maxLength: maxLength(100),
        hasLowercase,
        hasUppercase,
        hasNumeric,
        hasSpecialCharacter,
        passesApiValidation: passesApiValidation('password')
    },
    password_confirmation: {
        required,
        minLength: minLength(12),
        maxLength: maxLength(100),
        hasLowercase,
        hasUppercase,
        hasNumeric,
        hasSpecialCharacter,
        sameAs: sameAs('password'),
        passesApiValidation: passesApiValidation('password_confirmation')
    }
}

export const messages = {
    email: {
        required: 'Required',
        maxLength: 'This field can\'t be more than 100 characters long',
        email: 'Must be a valid email address',
    },
    password: {
        required: 'Required',
        minLength: 'Must be at least 12 characters long',
        maxLength: 'Can\'t be more than 100 characters long',
        hasLowercase: 'Must contain a lowercase character',
        hasUppercase: 'Must contain an uppercase character',
        hasNumeric: 'Must contain a numeric character',
        hasSpecialCharacter: 'Must contain a special character',
    },
    password_confirmation: {
        required: 'Required',
        minLength: 'Must be at least 12 characters long',
        maxLength: 'Can\'t be more than 100 characters long',
        hasLowercase: 'Must contain a lowercase character',
        hasUppercase: 'Must contain an uppercase character',
        hasNumeric: 'Must contain a numeric character',
        hasSpecialCharacter: 'Must contain a special character',
        sameAs: 'Must match new password'
    }
}
